import styled from "styled-components";

const VideoThumbnail = styled.div`
  position: relative;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    display: block;
    content: "";
    background: url(/assets/icon/icon-play.svg) center no-repeat;
    background-size: 25% auto;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    transition: background-size 0.1s ease-in-out;
  }
  &:hover {
    &:before {
      background-size: 30% auto;
    }
  }
`;

export default VideoThumbnail;
